import axios from 'axios';

// search vat input api
export async function searchEwtAPI(Data) {
	let ewtlist = [];
	const ewtVal = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/ewt/search/?ewtName=${ewtVal}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		ewtlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return ewtlist;
}

// check existing vat input api
export async function getEwtAPI(Data) {
	let ewtlist = [];
	const ewtName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/ewt/getewt/?ewtName=${ewtName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		ewtlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return ewtlist;
}

//create status api
export async function createEwtAPI(Data, userID) {
	let ewtData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/ewt/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		ewtData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return ewtData;
}

//update status api
export async function updateEwtAPI(Data, ewtID, userID) {
	let ewtData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/ewt/update/?ewtID=${ewtID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		ewtData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return ewtData;
}